module.exports = require("./se-NO");